import { useMutation, useQueryClient } from 'react-query';

import { apiClient } from 'src/services/api/client';
import { queryKeys } from 'src/services/api/constants';
import type { IMessage } from 'src/services/api/messages/types';
import type { IGetLeadMessagesWithAttachmentsResponse } from 'src/services/api/messages/use-lead-messages';

const TRANSLATE_PATH = 'api/landlord/messages/translation';

type ITranslationResponse = {
    message: IMessage
}

export const useTranslateMessage = (leadUuid: string) => {
    const queryClient = useQueryClient();

    return useMutation(
        async (messageUuid: string) => {
            return await apiClient(TRANSLATE_PATH, {
                method: 'post',
                json: { message_uuid: messageUuid },
            }).json<ITranslationResponse>();
        },
        {
            onSuccess: ({ message }) => {
                queryClient.setQueryData(
                    [queryKeys.messages, leadUuid],
                    (prev: IGetLeadMessagesWithAttachmentsResponse | IMessage[] | undefined): IGetLeadMessagesWithAttachmentsResponse | IMessage[] => {
                        if (!prev) { return []; }
                        const replaceMsg = (m: IMessage) => m.uuid === message.uuid ? message : m;
                        if (Array.isArray(prev)) {
                            return prev.map(replaceMsg);
                        }
                        return { ...prev, messages: prev.messages.map(replaceMsg) };
                    }
                );
            },
        }
    );
};
